module.exports = __webpack_public_path__ + "img/be.22ecfc59.svg";